/**
 * Custom podcast show — AJAX tag tabs + audio durations.
 */
(function () {
  'use strict';

  function formatDuration(seconds) {
    if (!seconds || !isFinite(seconds) || seconds < 0) return '--';
    var total = Math.round(seconds);
    var mins = Math.floor(total / 60);
    var secs = total % 60;
    return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
  }

  function bindDuration(wrap) {
    if (!wrap || wrap.getAttribute('data-podcast-ready') === 'true') return;
    wrap.setAttribute('data-podcast-ready', 'true');

    var audio = wrap.querySelector('[data-podcast-audio]');
    var timeEl = wrap.querySelector('[data-podcast-time]');
    if (!audio || !timeEl) return;

    function update() {
      if (audio.duration && isFinite(audio.duration)) {
        timeEl.textContent = formatDuration(audio.duration);
      }
    }

    audio.addEventListener('loadedmetadata', update);
    audio.addEventListener('durationchange', update);

    if (audio.readyState >= 1) {
      update();
    }
  }

  function bindDurations(root) {
    root.querySelectorAll('[data-podcast-duration]').forEach(bindDuration);
  }

  function withAjaxView(url, view, perPage) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('view', view);
    if (perPage) parsed.searchParams.set('cps_per_page', String(perPage));
    return parsed.pathname + parsed.search;
  }

  function setActiveTab(root, tabValue) {
    root.querySelectorAll('[data-podcast-tabs] [data-tab]').forEach(function (tab) {
      var isActive = tab.getAttribute('data-tab') === tabValue;
      tab.classList.toggle('is-active', isActive);
      if (isActive) {
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.removeAttribute('aria-current');
      }
    });
  }

  function loadResults(root, requestUrl, tabValue) {
    var results = root.querySelector('[data-podcast-results]');
    var blogUrl = root.getAttribute('data-blog-url');
    var ajaxView = root.getAttribute('data-ajax-view') || 'cps-ajax';
    var perPage = root.getAttribute('data-per-page');
    if (!results || !blogUrl) return;

    if (root.getAttribute('data-podcast-loading') === 'true') return;
    root.setAttribute('data-podcast-loading', 'true');
    root.classList.add('is-loading');

    var fetchUrl = withAjaxView(requestUrl, ajaxView, perPage);

    fetch(fetchUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Podcast fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextResults = doc.querySelector('[data-podcast-results]');
        if (!nextResults) throw new Error('Podcast results missing');

        results.innerHTML = nextResults.innerHTML;
        if (tabValue) setActiveTab(root, tabValue);
        bindDurations(root);
      })
      .catch(function () {
        // Keep current results if the ajax request fails.
      })
      .finally(function () {
        root.removeAttribute('data-podcast-loading');
        root.classList.remove('is-loading');
      });
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-podcast-init') === 'true') return;
    if (root.classList.contains('custom-podcast-show--ajax')) return;

    root.setAttribute('data-podcast-init', 'true');
    bindDurations(root);

    var blogUrl = root.getAttribute('data-blog-url');
    if (!blogUrl) return;

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-podcast-tabs] [data-tab]');
      if (tab && root.contains(tab)) {
        event.preventDefault();
        var tag = tab.getAttribute('data-tab') || 'all';
        var requestUrl = tag === 'all' ? blogUrl : blogUrl + '/tagged/' + encodeURIComponent(tag);
        loadResults(root, requestUrl, tag);
        return;
      }

      var pageLink = event.target.closest('[data-podcast-results] .pagination a');
      if (pageLink && root.contains(pageLink)) {
        event.preventDefault();
        var href = pageLink.getAttribute('href');
        if (!href) return;
        var activeTab = root.querySelector('[data-podcast-tabs] [data-tab].is-active');
        var tabValue = activeTab ? activeTab.getAttribute('data-tab') : 'all';
        loadResults(root, href, tabValue);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="custom-podcast-show"]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-section-type="custom-podcast-show"]')
      : null;
    if (section) {
      section.removeAttribute('data-podcast-init');
      section.querySelectorAll('[data-podcast-duration]').forEach(function (wrap) {
        wrap.removeAttribute('data-podcast-ready');
      });
      initRoot(section);
    } else {
      initAll();
    }
  });
})();
